import { displayFilterCategory } from "@common/components/SelectFilterOptions/utils";
import { FilterCategoryEnum, FilterOption } from "@common/utils/graphql";
import { Body } from "@hypercard/web-components";
import { Funnel, X } from "@phosphor-icons/react";

type Props = {
  filterBy: FilterOption[];
  onRemoveFilter: (index: FilterOption) => void;
};

export const FilterByChips = ({ filterBy, onRemoveFilter }: Props) => {
  return (
    <div className="flex flex-wrap items-center justify-start gap-2">
      {filterBy.map((filter) => (
        <button
          className="group flex items-center rounded-full bg-[#292929] p-1"
          key={`filter-chip-${filter.displaySubtitle}-${filter.id}`}
        >
          <button
            className="flex h-[25px] w-[25px] items-center justify-center rounded-full transition-colors hover:bg-white/10"
            onClick={() => onRemoveFilter(filter)}
          >
            <X size={12} weight="bold" className="hidden group-hover:block" />
            <Funnel
              size={12}
              weight="bold"
              className="block group-hover:hidden"
            />
          </button>
          <Body
            size="sm"
            weight="regular"
            className="ml-1 text-white/70 group-hover:underline"
          >
            {filter.category === FilterCategoryEnum.CustomField
              ? filter.displaySubtitle
              : displayFilterCategory(filter.category)}
          </Body>
          <div className="ml-3 rounded-full bg-white/10 px-2 py-1">
            <Body size="sm" weight="regular" className="text-white/70">
              {filter.displayTitle}
            </Body>
          </div>
        </button>
      ))}
    </div>
  );
};
